import React, { useContext } from 'react';
import DevicesTab from './devices/DevicesTab';
import RecordingsTab from './recordings/RecordingsTab';
import AnalyticsTab from './analytics/AnalyticsTab';
import MonitoringTab from './monitoring/MonitoringTab';

import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import {
    Badge,
    Box,
    Card,
    Divider,
    IconButton,
    Typography
} from '@mui/joy';
import { MdLogout } from 'react-icons/md';

// Import the SocketContext
import { SocketContext } from '../contexts/SocketContext';

function TabsRoot() {
    // Pull connection data from SocketContext
    const { isConnected, isPeerConnected } = useContext(SocketContext);

    return (
        <Tabs aria-label="tabs" defaultValue={0} sx={{ bgcolor: 'transparent' }}>
            <TabList
                disableUnderline
                sx={{
                    p: 1,
                    gap: 0.5,
                    borderRadius: 'xl',
                    bgcolor: 'background.level2',
                    flexWrap: 'nowrap',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    // This targets the selected Tab style
                    [`& .${tabClasses.root}[aria-selected="true"]`]: {
                        boxShadow: 'sm',
                        bgcolor: 'background.surface',
                    },
                }}
            >
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Tab disableIndicator>Analytics</Tab>
                    <Tab disableIndicator>Recordings</Tab>
                    <Tab disableIndicator>Devices</Tab>
                    <Tab disableIndicator>Monitoring</Tab>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        marginRight: 3,
                    }}
                >
                    {/* Signaling badge: success if isConnected is true, otherwise danger */}
                    <Badge color={isConnected ? 'success' : 'danger'}>
                        <Typography level="body2" color="gray">
                            Signaling
                        </Typography>
                    </Badge>

                    <Divider orientation="vertical" />

                    {/* AI Hub badge: success if isPeerConnected is true, otherwise danger */}
                    <Badge color={isPeerConnected ? 'success' : 'danger'}>
                        <Typography level="body2" color="gray">
                            AI Hub
                        </Typography>
                    </Badge>

                    <IconButton size="sm" variant="plain" color="neutral" sx={{ marginLeft: 4 }}>
                        <MdLogout />
                    </IconButton>
                </Box>
            </TabList>

            <Card
                sx={(theme) => ({
                    marginTop: 2,
                    height: '80vh',
                })}
            >
                <Box
                    sx={(theme) => ({
                        '--bg': theme.vars.palette.background.surface,
                        // margin: 1,
                        background: 'var(--bg)',
                        // boxShadow: '0 0 0 100vmax var(--bg)',
                        // clipPath: 'inset(0 -100vmax)',
                        borderRadius: 'l',
                    })}
                >
                    <TabPanel value={0}>
                        <AnalyticsTab />
                    </TabPanel>
                    <TabPanel value={1}>
                        <RecordingsTab />
                    </TabPanel>
                    <TabPanel value={2}>
                        <DevicesTab />
                    </TabPanel>
                    <TabPanel value={3}>
                        <MonitoringTab />
                    </TabPanel>
                </Box>
            </Card>
        </Tabs>
    );
}

export default TabsRoot;
